<template>
  <div class="results-tip">
    <img
      alt="search icon"
      src="/img/search.svg"
    >
    <h1 class="tip-title tac">
      <slot name="title">
        {{ t('Sorry, no results were found') }}
      </slot>
    </h1>
    <span class="tip-description">
      <slot>
        Change the search parameters and try again. Good luck!
      </slot>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style lang="scss">
.results-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 32rem;
  height: 33.6rem;
  background: rgba(255, 255, 255, 0.01);
  border-radius: 1.2rem;

  .tip-title {
    margin-top: 5rem;
    font-weight: 600;
    font-size: 2rem;
    line-height: 2.7rem;
    color: var(--surfaces-on-surface);
  }

  .tip-description {
    margin-top: 0.8rem;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.6rem;
    color: var(--surfaces-on-surface);
    opacity: 0.8;
    max-width: 21.7rem;
    text-align: center;
  }
}
</style>
